function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M96.0807 30.9946L66.1812 1.0951C65.4833 0.396926 64.5307 0 63.538 0H11.2126C5.02997 0 0 5.02997 0 11.2126V116.362C0 122.544 5.02997 127.574 11.2126 127.574H85.9632C92.1458 127.574 97.1758 122.544 97.1758 116.362V33.6378C97.1758 32.6187 96.748 31.6616 96.0807 30.9946ZM67.2755 12.7607L84.4151 29.9002H71.0131C68.9522 29.9002 67.2755 28.2236 67.2755 26.1627V12.7607ZM85.9632 120.099H11.2126C9.15172 120.099 7.47506 118.423 7.47506 116.362V11.2126C7.47506 9.15172 9.15172 7.47506 11.2126 7.47506H59.8005V26.1627C59.8005 32.3453 64.8304 37.3753 71.0131 37.3753H89.7007V116.362C89.7007 118.423 88.0241 120.099 85.9632 120.099Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M71.0137 52.8242H26.1633C24.0992 52.8242 22.4258 54.4976 22.4258 56.5617C22.4258 58.6259 24.0992 60.2993 26.1633 60.2993H71.0137C73.0778 60.2993 74.7512 58.6259 74.7512 56.5617C74.7512 54.4976 73.0778 52.8242 71.0137 52.8242Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M71.0137 67.7734H26.1633C24.0992 67.7734 22.4258 69.4469 22.4258 71.511C22.4258 73.5751 24.0992 75.2485 26.1633 75.2485H71.0137C73.0778 75.2485 74.7512 73.5751 74.7512 71.511C74.7512 69.4469 73.0778 67.7734 71.0137 67.7734Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M71.0137 82.7236H26.1633C24.0992 82.7236 22.4258 84.397 22.4258 86.4612C22.4258 88.5253 24.0992 90.1987 26.1633 90.1987H71.0137C73.0778 90.1987 74.7512 88.5253 74.7512 86.4612C74.7512 84.397 73.0778 82.7236 71.0137 82.7236Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M56.0636 97.6738H26.1633C24.0992 97.6738 22.4258 99.3472 22.4258 101.411C22.4258 103.475 24.0992 105.149 26.1633 105.149H56.0636C58.1277 105.149 59.8011 103.475 59.8011 101.411C59.8011 99.3472 58.1277 97.6738 56.0636 97.6738Z"
});

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 128,
    viewBox: "0 0 98 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.016f08a4.svg";
export { ForwardRef as ReactComponent };